<template>
  <div class="homeStyle">
    <Tabbar @toMore="toMore" :title="title" :enlishTitle="enlishTitle"></Tabbar>
    <Empty v-if="isEmpty"></Empty>
    <TalentList :resultList="resultList" v-else></TalentList>
  </div>
</template>

<script>
import Tabbar from './Tabbar.vue'
import { getTalentDataList } from '@/api/MTalentData.js';
import TalentList from '../../MTalentData/component/talentList.vue'
import Empty from '@/components/common/Empty';

export default {
  data() {
    return {
      title: '人才智库',
      enlishTitle: 'POOL OF HUMAN INTELLIGENCE',
      resultList: [],
      searchParams: {
        industry: '',
        expertsType: '',
        pageSize: 6,
        pageNum: 1,
      },
      isEmpty: false
    }
  },
  mounted() {
    this.loadData()
  },
  components: {
    Tabbar,
    TalentList,
    Empty
  },
  methods: {
    toMore() {
      this.$router.push({ path: '/talentList' })
    },
    async loadData() {
      try {
        this.loading = true;
        const { data } = await getTalentDataList(this.searchParams);
        const { rows } = data;
        this.isEmpty = rows.length === 0;
        this.resultList = rows;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
}
</script>